import { getFabricSellerTrustType } from '@/service/fabric-api'
import { create } from 'zustand'

export enum TrustType {
  // 全店托管
  All = 1,
  // 面料托管
  Fabric = 2,
  // 推广项目托管
  Promotion = 3,
  // 店铺管理托管
  Shop = 4,
  // 客户咨询托管
  Consult = 5,
  // 辅料托管
  Accessory = 6,
}

export interface AuthInfo {
  productId: number
  productName: string
  skuId: number
  skuName: string
  productBeginTime: string
  productEndTime: string
  signStatus: number
  effect: number
  userLimit: number
  ipLimit: number
}

export enum SellerMode {
  Standard = 'standard',
  Accessory = 'accessory',
  LightFabric = 'light-fabric',
}

export function resolveSellerMode(data: AuthInfo[]) {
  const zxbSkuNames = data.filter(isActiveZxbProduct).map((item) => item.skuName || '')
  const isAccessoryLight = (name: string) => name.includes('轻入驻') && name.includes('辅料')
  const isFabricLight = (name: string) => name.includes('轻入驻') && name.includes('面料')

  if (zxbSkuNames.some((name) => !isAccessoryLight(name) && !isFabricLight(name))) return SellerMode.Standard
  if (zxbSkuNames.some(isAccessoryLight)) return SellerMode.Accessory
  if (zxbSkuNames.some(isFabricLight)) return SellerMode.LightFabric
  return SellerMode.Standard
}

export function isActiveZxbProduct(item: AuthInfo) {
  const now = new Date()
  const today = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-')
  const beginAt = item.productBeginTime?.slice(0, 10)
  const endAt = item.productEndTime?.slice(0, 10)
  return item.productId === 25 && item.effect === 1 && (!beginAt || beginAt <= today) && Boolean(endAt && endAt >= today)
}

interface BaseStore {
  hasZXBrole: boolean
  authReady: boolean
  sellerMode: SellerMode
  authInfo: AuthInfo[]
  getAuthInfo: (data: AuthInfo[]) => Promise<void>
  trustTypeList: TrustType[]
  getSellerTrustType: () => void
}

export const useBaseStore = create<BaseStore>((set) => ({
  hasZXBrole: false,
  authReady: false,
  sellerMode: SellerMode.Standard,
  authInfo: [],
  getAuthInfo: async (data: AuthInfo[]) => {
    const hasZXBrole = data.some(isActiveZxbProduct)
    set({ authInfo: data, authReady: true, hasZXBrole, sellerMode: resolveSellerMode(data) })
  },
  trustTypeList: [],
  getSellerTrustType: async () => {
    const trustType = await getFabricSellerTrustType()
    set({ trustTypeList: trustType?.trustType || [] })
  },
}))
